export default "__VITE_ASSET__7e8de245__"